export const toastTypes = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

const getAuthMessage = (action) => `you have ${action} successfully`;
const getCRUDMessage = (target, action) => `Hurray! ${target} ${action} successfully`;

export const toastMessages = {
  // AUTH
  LOGIN_SUCCESS: getAuthMessage('logged in'),
  LOGOUT_SUCCESS: getAuthMessage('logged out'),
  CHANGE_PASSWORD_SUCCESS: getAuthMessage('updated password'),

  // DASHBOARD

  MESSAGE_CREATE_SUCCESS: getCRUDMessage('message', 'created'),
  MESSAGE_UPDATE_SUCCESS: getCRUDMessage('message', 'updated'),
  MESSAGE_DELETE_SUCCESS: getCRUDMessage('message', 'deleted'),

  GENERAL_ERROR: 'Oops! something went wrong',
  ACCESS_ERROR: 'Please provide access to user',

  ADD_AREA_SUCCESS: 'Area created successfully',
};

export const USER_STATUS = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
};

export const USER_VERIFY_STATUS = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
};

export const CATEGORY_STATUS = {
  ACTIVE: 'ACTIVE',
  DEACTIVE: 'DEACTIVE',
};
export const PRODUCT_ITEMS_STATUS = {
  ACTIVE: 'ACTIVE',
  DEACTIVE: 'DEACTIVE',
};

export const ITEM_STATUS = {
  ACTIVE: 'ACTIVE',
  DEACTIVE: 'DEACTIVE',
};

export const LEAVE_STATUS = {
  IN_PROGRESS: 'In progress',
  APPROVED: 'Accepted',
  REJECTED: 'Rejected',
};

export const CANCELLATION_ORDER_STATUS = {
  PENDING: 'Pending',
  APPROVED: 'Accepted',
  REJECTED: 'Rejected',
};

export const ORDER_EVENT_TYPES = [
  {
    label: 'Monthly',
    value: 'monthly',
  },
  {
    label: 'One-Time',
    value: 'oneTime',
  },
  {
    label: 'Event',
    value: 'event',
  },
];

export const ORDER_TYPE = {
  MONTHLY: 'monthly',
  ONE_TIME: 'oneTime',
  EVENT: 'event',
};

export const STORAGE_KEYS = {
  AUTH: '@auth',
  AUTH_TOKEN: '@authToken',
  USER_ONBOARD: '@onBoarded',
  DEVICE_ID: '@deviceId',
  LANGUAGE: '@i18nextLng',
  ORDER_REQUEST: '@order_request',
};

export const USER_ROLES = {
  ADMIN: 'admin',
  USER: 'user',
};
